import { render, staticRenderFns } from "./PortletRecommendedActions.vue?vue&type=template&id=14ae8734"
import script from "./PortletRecommendedActions.vue?vue&type=script&lang=js"
export * from "./PortletRecommendedActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports